<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getConstructedRouteGeoJson.data.id"
      :source="getConstructedRouteGeoJson"
      :layerId="getConstructedRouteLineLayer.id"
      :layer="getConstructedRouteLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getConstructedRouteGeoJson.data.id"
      :source="getConstructedRouteGeoJson"
      :layerId="getConstructedRoutePointsLayer.id"
      :layer="getConstructedRoutePointsLayer"
    />
    <MglGeojsonLayer
      :sourceId="getConstructedRoutePointsGeoJson.data.id"
      :source="getConstructedRoutePointsGeoJson"
      :layerId="getConstructedRouteSymbolLayer.id"
      :layer="getConstructedRouteSymbolLayer"
    />
  </div>
</template>
          
          <script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "ConstructedRouteLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/createRouteModule", [
      "getConstructedRouteGeoJson",
      "getConstructedRouteLineLayer",
      "getConstructedRoutePointsLayer",
      "getConstructedRoutePointsGeoJson",
      "getConstructedRouteSymbolLayer",
    ]),
  },
};
</script>